import React, { Fragment, useContext, useState } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SettingsIcon from "@mui/icons-material/Settings";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TimerIcon from "@mui/icons-material/Timer";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LockResetIcon from "@mui/icons-material/LockReset";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import PolicyIcon from "@mui/icons-material/Policy";
import CampaignIcon from "@mui/icons-material/Campaign";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ChecklistIcon from "@mui/icons-material/Checklist";
import DescriptionIcon from "@mui/icons-material/Description";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

import AuthContext from "../context/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";
import Screensize from "../hooks/resize";
import { getUserName, getAccessToken, getUserId, getPostLwdNotice } from "../helpers/tokenService";
import axios from "axios";
import API_BASE_URL from "../helpers/apiConfig";

const SideNav = ({ onClick, role, setToggle, currentTab }) => {
  const { logout } = useContext(AuthContext);
  const { screenWidth } = Screensize();
  const userId = getUserId();
  const isManagerUser = userId === "RT0101" || userId === "RT0288";

  const postLwdNotice = getPostLwdNotice();
  const isPostLwd = postLwdNotice && postLwdNotice.isGracePeriod;

  const [expandedMenu, setExpandedMenu] = useState("");
  const empfirstname = role === 'admin' ? 'admin' : (getUserName() || 'Employee');

  const [notifications, setNotifications] = useState({
    profileRequests: 0,
    reimbursements: 0,
    referrals: 0,
    leaves: 0,
    announcements: 0,
    activeJobs: 0
  });

  const fetchNotificationCounts = async () => {
    try {
      const token = getAccessToken();
      if (!token) return;
      const res = await axios.get(`${API_BASE_URL}/notifications/counts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data && res.data.counts) {
        setNotifications(res.data.counts);
      }
    } catch (err) {
      console.error("Error fetching sidebar notification counts:", err);
    }
  };

  React.useEffect(() => {
    fetchNotificationCounts();
    const interval = setInterval(fetchNotificationCounts, 15000);
    return () => clearInterval(interval);
  }, []);

  const renderBadge = (count) => {
    if (!count || count <= 0) return null;
    return (
      <span 
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ef4444',
          color: '#ffffff',
          fontSize: '9px',
          fontWeight: 'bold',
          borderRadius: '10px',
          padding: '1px 5px',
          minWidth: '14px',
          height: '14px',
          marginLeft: '6px',
          verticalAlign: 'middle',
          lineHeight: 1
        }}
      >
        {count}
      </span>
    );
  };

  React.useEffect(() => {
    if (currentTab) {
      if (currentTab === "dashboard") {
        setExpandedMenu("");
      } else if (["Offer letter", "Offer letter log", "Document entry", "Assets details", "Assets assignment", "Referrals", "ActiveJobs", "All On board "].includes(currentTab)) {
        setExpandedMenu("On board");
      } else if (["Employee master", "ProfileRequests", "Salary master", "Category", "Calendar", "Announcements", "All employees"].includes(currentTab)) {
        setExpandedMenu("Employees");
      } else if (["Attendence regularization", "In out activities", "Daily attendence", "Salary register", "View Uploaded Attendance", "Manage shift", "All Attendence"].includes(currentTab)) {
        setExpandedMenu("Attendence");
      } else if (["Leave balance", "Leave Policy", "LeaveCalendar", "All Leaves", ...(role === "admin" ? ["Approvals"] : [])].includes(currentTab)) {
        setExpandedMenu("Leave");
      } else if (["Salary process", "Bank transfer", "BankDetail", "Salary paySilp", "Form 16", ...(role === "admin" ? ["Final settlement", "Reimbursement"] : []), "All payroll"].includes(currentTab)) {
        setExpandedMenu("Payroll");
      } else if (isManagerUser && ["Reimbursement", "Final settlement"].includes(currentTab)) {
        setExpandedMenu("ReimbursementFNF");
      } else if (["EPF", "ESIC"].includes(currentTab)) {
        setExpandedMenu("Complains");
      } else if (["Loans"].includes(currentTab)) {
        setExpandedMenu("Loans");
      } else if (["Survey"].includes(currentTab)) {
        setExpandedMenu("Survey");
      } else if (["Settings", "Settings-Organization", "Settings-Attendance", "Settings-Leave", "Settings-Payroll", "Settings-Notifications", "Settings-Password"].includes(currentTab)) {
        setExpandedMenu("Settings");
      }
    }
  }, [currentTab, role, isManagerUser]);

  const handleMenuClick = (menuName) => {
    setExpandedMenu(expandedMenu === menuName ? "" : menuName);
  };

  const handleLinkClick = (pageName) => {
    if (isPostLwd && ["Apply leave", "PunchTime", "Attendance Regularization", "Reimbursement", "Referral Request"].includes(pageName)) {
      alert("Action restricted: Access is limited to document viewing & downloads after your Last Working Day.");
      return;
    }
    onClick(pageName);
    if (screenWidth < 900) {
      setToggle(true);
    }
  };

  const isSubPage = currentTab && currentTab !== "dashboard";

  return (
    <div className={`side-menu light-theme ${isSubPage ? "subpage-active" : ""}`}>
      <div className="side-menu-scroll-container">
        <ul className="side-menu-list">
          <li className={`accordion-item ${expandedMenu === "dashboard" ? "expanded" : ""}`}>
            <div className={`accordion-header ${currentTab === "dashboard" ? "active-link" : ""}`} onClick={() => handleLinkClick("dashboard")}>
              <span className="accordion-title">
                <DashboardIcon /> Dashboard
              </span>
            </div>
          </li>

          {role === "admin" && (
            <Fragment>
              <li className={`accordion-item ${expandedMenu === "On board" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("On board")}>
                  <span className="accordion-title">
                    <PersonAddAltIcon /> On Board {renderBadge(notifications.referrals)}
                  </span>
                  {expandedMenu === "On board" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "On board" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Offer letter" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Offer letter")}>Offer Letter</li>
                  <li className={currentTab === "Offer letter log" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Offer letter log")}>Offer Letter Log</li>
                  <li className={currentTab === "Document entry" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Document entry")}>Document Entry</li>
                  <li className={currentTab === "Assets details" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Assets details")}>Assets Details</li>
                  <li className={currentTab === "Assets assignment" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Assets assignment")}>Assets Assignment</li>
                  <li className={currentTab === "Referrals" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Referrals")}>Referral Requests {renderBadge(notifications.referrals)}</li>
                  <li className={currentTab === "ActiveJobs" ? "active-sub-link" : ""} onClick={() => handleLinkClick("ActiveJobs")}>Active Jobs</li>
                  {/* <li className={currentTab === "All On board " ? "active-sub-link" : ""} onClick={() => handleLinkClick("All On board ")}>All</li> */}
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Employees" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Employees")}>
                  <span className="accordion-title">
                    <PeopleOutlineIcon /> Employees {renderBadge(notifications.profileRequests)}
                  </span>
                  {expandedMenu === "Employees" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Employees" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Employee master" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Employee master")}>Employee Master</li>
                  <li className={currentTab === "Salary master" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Salary master")}>Salary Master</li>
                  <li className={currentTab === "Category" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Category")}>Category</li>
                  <li className={currentTab === "Calendar" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Calendar")}>Calendar</li>
                  <li className={currentTab === "ProfileRequests" ? "active-sub-link" : ""} onClick={() => handleLinkClick("ProfileRequests")}>Profile Requests {renderBadge(notifications.profileRequests)}</li>
                  <li className={currentTab === "Announcements" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Announcements")}>Announcements</li>
                  <li className={currentTab === "All employees" ? "active-sub-link" : ""} onClick={() => handleLinkClick("All employees")}>Master Data</li>
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Attendence" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Attendence")}>
                  <span className="accordion-title">
                    <AccessTimeIcon /> Attendance
                  </span>
                  {expandedMenu === "Attendence" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Attendence" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Attendence regularization" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Attendence regularization")}>Attendence Regularization</li>
                  <li className={currentTab === "In out activities" ? "active-sub-link" : ""} onClick={() => handleLinkClick("In out activities")}>In Out Activities Report</li>
                  <li className={currentTab === "Daily attendence" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Daily attendence")}>Daily Detail Attendence Report</li>
                  <li className={currentTab === "Salary register" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Salary register")}>Attendance Register</li>
                  <li className={currentTab === "View Uploaded Attendance" ? "active-sub-link" : ""} onClick={() => handleLinkClick("View Uploaded Attendance")}>View Uploaded Attendance</li>
                  <li className={currentTab === "Manage shift" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Manage shift")}>Manage Shift</li>
                  {/* <li className={currentTab === "All Attendence" ? "active-sub-link" : ""} onClick={() => handleLinkClick("All Attendence")}>All</li> */}
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Leave" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Leave")}>
                  <span className="accordion-title">
                    <EventAvailableIcon /> Leave {renderBadge(notifications.leaves)}
                  </span>
                  {expandedMenu === "Leave" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Leave" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Approvals" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Approvals")}>Approvals {renderBadge(notifications.leaves)}</li>
                  <li className={currentTab === "Leave balance" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Leave balance")}>Leave Balance Report</li>
                  <li className={currentTab === "Leave Policy" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Leave Policy")}>Leave Policy</li>
                  <li className={currentTab === "LeaveCalendar" ? "active-sub-link" : ""} onClick={() => handleLinkClick("LeaveCalendar")}>Leave Calendar</li>
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Payroll" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Payroll")}>
                  <span className="accordion-title">
                    <CurrencyRupeeIcon /> Payroll {renderBadge((notifications.reimbursements || 0) + (notifications.fnfApproved || 0))}
                  </span>
                  {expandedMenu === "Payroll" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Payroll" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Salary process" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Salary process")}>Salary Process</li>
                  <li className={currentTab === "Bank transfer" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Bank transfer")}>Salary Disbursement (Bank Transfer)</li>
                  <li className={currentTab === "BankDetail" ? "active-sub-link" : ""} onClick={() => handleLinkClick("BankDetail")}>Add Bank Details</li>
                   <li className={currentTab === "Salary paySilp" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Salary paySilp")}>Salary PaySilp</li>
                  <li className={currentTab === "Form 16" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Form 16")}>Form 16</li>
                  <li className={currentTab === "Final settlement" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Final settlement")}>Exit Settlements & Letters {renderBadge(notifications.fnfApproved)}</li>
                  <li className={currentTab === "Reimbursement" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Reimbursement")}>Reimbursement & FNF {renderBadge(notifications.reimbursements)}</li>
                  {/* <li className={currentTab === "All payroll" ? "active-sub-link" : ""} onClick={() => handleLinkClick("All payroll")}>All</li> */}
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Complains" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Complains")}>
                  <span className="accordion-title">
                    <NoteAltIcon /> Compliance
                  </span>
                  {expandedMenu === "Complains" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Complains" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "EPF" ? "active-sub-link" : ""} onClick={() => handleLinkClick("EPF")}>EPFO</li>
                  <li className={currentTab === "ESIC" ? "active-sub-link" : ""} onClick={() => handleLinkClick("ESIC")}>ESIC</li>
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Loans" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Loans")}>
                  <span className="accordion-title">
                    <CurrencyExchangeIcon /> Loans
                  </span>
                  {expandedMenu === "Loans" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Loans" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Loans" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Loans")}>Loan Application</li>
                  {/* <li className={currentTab === "Loans" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Loans")}>Loan Register</li>
                  <li className={currentTab === "Loans" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Loans")}>Loan Projection</li> */}
                  {/* <li className={currentTab === "Loans" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Loans")}>All</li> */}
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Survey" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Survey")}>
                  <span className="accordion-title">
                    <NoteAltIcon /> Survey
                  </span>
                  {expandedMenu === "Survey" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Survey" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Survey" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Survey")}>Survey All</li>
                </ul>
              </li>

              <li className={`accordion-item ${expandedMenu === "Settings" ? "expanded" : ""}`}>
                <div className="accordion-header" onClick={() => handleMenuClick("Settings")}>
                  <span className="accordion-title">
                    <SettingsIcon /> Settings
                  </span>
                  {expandedMenu === "Settings" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                </div>
                <ul className={`accordion-body ${expandedMenu === "Settings" ? "expanded-body" : "collapsed-body"}`}>
                  <li className={currentTab === "Settings-Organization" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Organization")}>Organization Setup</li>
                  <li className={currentTab === "Settings-Attendance" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Attendance")}>Attendance Setup</li>
                  <li className={currentTab === "Settings-Leave" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Leave")}>Leave Setup</li>
                  <li className={currentTab === "Settings-Payroll" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Payroll")}>Payroll Setup</li>
                  <li className={currentTab === "Settings-Notifications" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Notifications")}>Notifications Setup</li>
                  <li className={currentTab === "Settings-Password" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Settings-Password")}>Password Setup</li>
                </ul>
              </li>
            </Fragment>
          )}

          {role === "employee" && (
            <Fragment>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Profile" ? "active-link" : ""}`} onClick={() => handleLinkClick("Profile")}>
                  <span className="accordion-title">
                    <AccountBoxIcon /> My Profile
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "PunchTime" ? "active-link" : ""}`} onClick={() => handleLinkClick("PunchTime")}>
                  <span className="accordion-title">
                    <TimerIcon /> Punch In/Out
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "AttendenceRegularization" ? "active-link" : ""}`} onClick={() => handleLinkClick("AttendenceRegularization")}>
                  <span className="accordion-title">
                    <CalendarTodayIcon /> Attendance Regularization
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Apply leave" ? "active-link" : ""}`} onClick={() => handleLinkClick("Apply leave")}>
                  <span className="accordion-title">
                    <FlightTakeoffIcon /> Apply Leave
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Approvals" ? "active-link" : ""}`} onClick={() => handleLinkClick("Approvals")}>
                  <span className="accordion-title">
                    <ChecklistIcon /> Approvals {renderBadge(notifications.leaves)}
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "salarygenerate" ? "active-link" : ""}`} onClick={() => handleLinkClick("salarygenerate")}>
                  <span className="accordion-title">
                    <ReceiptIcon /> Salary Slip Download
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "EmpSalaryStructure" ? "active-link" : ""}`} onClick={() => handleLinkClick("EmpSalaryStructure")}>
                  <span className="accordion-title">
                    <ReceiptIcon /> My Salary Structure
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "EmpOfferLetter" ? "active-link" : ""}`} onClick={() => handleLinkClick("EmpOfferLetter")}>
                  <span className="accordion-title">
                    <DescriptionIcon /> My Offer Letter
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "EmpConfirmationLetter" ? "active-link" : ""}`} onClick={() => handleLinkClick("EmpConfirmationLetter")}>
                  <span className="accordion-title">
                    <AssignmentTurnedInIcon /> My Confirmation Letter
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Form 16" ? "active-link" : ""}`} onClick={() => handleLinkClick("Form 16")}>
                  <span className="accordion-title">
                    <ReceiptIcon /> Form 16 Download
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "EmpExitDocuments" ? "active-link" : ""}`} onClick={() => handleLinkClick("EmpExitDocuments")}>
                  <span className="accordion-title">
                    <NoteAltIcon /> My Exit Documents
                  </span>
                </div>
              </li>
              {isManagerUser ? (
                <li className={`accordion-item ${expandedMenu === "ReimbursementFNF" ? "expanded" : ""}`}>
                  <div className="accordion-header" onClick={() => handleMenuClick("ReimbursementFNF")}>
                    <span className="accordion-title">
                      <ReceiptIcon /> Reimbursement & FNF {renderBadge((notifications.reimbursements || 0) + (notifications.fnfPending || 0))}
                    </span>
                    {expandedMenu === "ReimbursementFNF" ? <KeyboardArrowUpIcon className="accordion-icon" /> : <KeyboardArrowDownIcon className="accordion-icon" />}
                  </div>
                  <ul className={`accordion-body ${expandedMenu === "ReimbursementFNF" ? "expanded-body" : "collapsed-body"}`}>
                    <li className={currentTab === "Reimbursement" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Reimbursement")}>
                      Reimbursements {renderBadge(notifications.reimbursements)}
                    </li>
                    <li className={currentTab === "Final settlement" ? "active-sub-link" : ""} onClick={() => handleLinkClick("Final settlement")}>
                      Full & Final Settlement (F&F) {renderBadge(notifications.fnfPending)}
                    </li>
                  </ul>
                </li>
              ) : (
                <li className="accordion-item">
                  <div className={`accordion-header ${currentTab === "Reimbursement" ? "active-link" : ""}`} onClick={() => handleLinkClick("Reimbursement")}>
                    <span className="accordion-title">
                      <ReceiptIcon />Reimbursements {renderBadge(notifications.reimbursements)}
                    </span>
                  </div>
                </li>
              )}
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Change Password" ? "active-link" : ""}`} onClick={() => handleLinkClick("Change Password")}>
                  <span className="accordion-title">
                    <LockResetIcon /> Change Password
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Holidays" ? "active-link" : ""}`} onClick={() => handleLinkClick("Holidays")}>
                  <span className="accordion-title">
                    <BeachAccessIcon /> Holidays
                  </span>
                </div>
              </li>
              {/* <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "ProfileRequests" ? "active-link" : ""}`} onClick={() => handleLinkClick("ProfileRequests")}>
                  <span className="accordion-title">
                    <ChecklistIcon /> Profile Requests
                  </span>
                </div>
              </li> */}
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Leave Policy" ? "active-link" : ""}`} onClick={() => handleLinkClick("Leave Policy")}>
                  <span className="accordion-title">
                    <PolicyIcon /> Leave Policy
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Announcements" ? "active-link" : ""}`} onClick={() => handleLinkClick("Announcements")}>
                  <span className="accordion-title">
                    <CampaignIcon /> Announcements {renderBadge(notifications.announcements)}
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "Referral Request" ? "active-link" : ""}`} onClick={() => handleLinkClick("Referral Request")}>
                  <span className="accordion-title">
                    <HandshakeIcon /> Referral Requests
                  </span>
                </div>
              </li>
              <li className="accordion-item">
                <div className={`accordion-header ${currentTab === "ActiveJobs" ? "active-link" : ""}`} onClick={() => handleLinkClick("ActiveJobs")}>
                  <span className="accordion-title">
                    <WorkOutlineIcon /> Active Jobs {renderBadge(notifications.activeJobs)}
                  </span>
                </div>
              </li>
            </Fragment>
          )}
        </ul>
      </div>
      {screenWidth < 900 && (
        <div className="side-menu-logout-bottom">
          <div
            onClick={logout}
            style={{
              color: '#ef4444',
              backgroundColor: 'rgba(239, 68, 68, 0.08)',
              borderRadius: '12px',
              padding: '12px 16px',
              display: 'flex',
              gap: '15px',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
              fontWeight: 700,
              width: '100%',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.15)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.08)'}
          >
            <span className="accordion-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <LogoutIcon sx={{ fontSize: 20 }} /> Logout
            </span>
            <span style={{ fontSize: '0.85rem', opacity: 0.8, fontWeight: 500 }}>
              {empfirstname}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideNav;
